import { render, staticRenderFns } from "./PNGButtons.vue?vue&type=template&id=5dd2c8f9&scoped=true"
import script from "./PNGButtons.vue?vue&type=script&lang=js"
export * from "./PNGButtons.vue?vue&type=script&lang=js"
import style0 from "./PNGButtons.vue?vue&type=style&index=0&id=5dd2c8f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd2c8f9",
  null
  
)

export default component.exports